"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitcherOption = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["onChange", "children", "checked", "size", "classes", "disabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cb6299e8c{position:relative}.c5d728bca{display:none}.c3938eb14{position:absolute;cursor:pointer;background:var(--color-flomni-gray-40);transition:background var(--animation-timing-def) ease}.c3938eb14:before{content:'';position:absolute;background:#fff;border-radius:100%;transition:left var(--animation-timing-def) ease;box-shadow:0 .09rem .15rem rgba(0,0,0,.2)}.ce817dd08{display:block;cursor:pointer;color:var(--color-flomni-gray-70)}.c61363724{opacity:.3}.c61363724 .c3938eb14{cursor:default}.c61363724 .ce817dd08{cursor:default}.c58422a57 .c3938eb14{background:var(--color-flomni-blue-70)}.c58422a57 .ce817dd08{color:var(--color-flomni-gray-90)}.c6f5f8c8e .c3938eb14{width:1.625rem;height:1rem;border-radius:1rem;margin-top:.0625rem}.c6f5f8c8e .c3938eb14:before{top:.125rem;left:.125rem;width:.75rem;height:.75rem}.c6f5f8c8e .ce817dd08{margin-left:2.625rem;font-size:.875rem;font-weight:400;line-height:1.25rem}.c6f5f8c8e.c58422a57 .c3938eb14:before{left:.75rem}.c27a01d6d .c3938eb14{width:2.375rem;height:1.5rem;border-radius:1.5rem}.c27a01d6d .c3938eb14:before{top:.1875rem;left:.1875rem;width:1.125rem;height:1.125rem}.c27a01d6d .ce817dd08{box-sizing:content-box;min-height:1.3125rem;padding-top:.1875rem;margin-left:3.375rem;font-size:1rem;font-weight:400;line-height:1.125rem}.c27a01d6d.c58422a57 .c3938eb14:before{left:1.0625rem}");
var styles = {
  root: 'cb6299e8c',
  input: 'c5d728bca',
  switcher: 'c3938eb14',
  label: 'ce817dd08',
  '--disabled': 'c61363724',
  '--checked': 'c58422a57',
  '--size-small': 'c6f5f8c8e',
  '--size-usual': 'c27a01d6d'
};

var SwitcherOption = function SwitcherOption(props) {
  var onChange = props.onChange,
      children = props.children,
      checked = props.checked,
      size = props.size,
      classes = props.classes,
      disabled = props.disabled,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var inputEl = (0, _react.useRef)(null);
  var onSwitcherClickHandler = (0, _react.useCallback)(function () {
    inputEl.current.click();
  }, []);
  var onLabelClickHandler = (0, _react.useCallback)(function () {
    if (rest.id) return;
    inputEl.current.click();
  }, [rest.id]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.size[size], (0, _defineProperty2.default)({}, cn.checked, checked), (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    ref: inputEl,
    className: cn.input,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    onChange: onChange
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.switcher,
    onClick: onSwitcherClickHandler
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: rest.id,
    className: cn.label,
    onClick: onLabelClickHandler
  }, children));
};

exports.SwitcherOption = SwitcherOption;
var size = ['usual', 'small'];
SwitcherOption.modes = {
  size: size
};
SwitcherOption.propTypes = {
  /* component logic props */
  onChange: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  checked: _propTypes.bool.isRequired,
  disabled: _propTypes.bool,

  /* styling modificators */
  size: (0, _propTypes.oneOf)(['usual', 'small']),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SwitcherOption.defaultProps = {
  disabled: false,
  size: 'usual',
  classes: {}
};